import { SET_SETTINGS_OPEN } from '../actionConstants';

export const setSettingsOpenAction = (payload) => {
  return {
    type: SET_SETTINGS_OPEN,
    payload,
  };
};
